import { ItemSummaryFilter } from './ItemSummary'
import { ProjectType } from '../../../common/constants'
import API from '../../api'

const projectTypeToUrlSegment: Record<ProjectType, string> = {
  1: 'projects',
  2: 'tickets',
  3: 'maintenance',
}

export type PrintItemsSummaryRequest = {
  jobId: number
  jobType: ProjectType
  filter: ItemSummaryFilter
}

export const printItemsSummaryReport = async (request: PrintItemsSummaryRequest): Promise<string> => {
  const typeName = projectTypeToUrlSegment[request.jobType]
  const response = await API.post(`/projecttickets/${typeName}/${request.jobId}/items-summary-report/upload`, request.filter)
  return response.data.url
}
